(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dn-car-steps-feature"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root = document) => root.querySelectorAll('[data-dn-car-feature]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const form = section.querySelector('form');
    const buttons = [...form.querySelectorAll('[data-dn-car-add]')];
    const status = form.querySelector('[data-dn-car-status]');
    const error = form.querySelector('[data-dn-car-error]');
    const labels = JSON.parse(form.querySelector('[data-dn-car-labels]').textContent);
    let pending = false;
    form.addEventListener('submit', async event => {
      if (!event.submitter?.hasAttribute('data-dn-car-add')) return;
      event.preventDefault();
      if (pending || event.submitter?.disabled || !form.reportValidity()) return;
      const buyNow = event.submitter?.hasAttribute('data-dn-car-buy');
      const base = window.Shopify?.routes?.root || '/';
      const checkoutWindow = buyNow && window.Shopify?.designMode ? window.open('about:blank', '_blank') : null;
      pending = true;
      error.hidden = status.hidden = true;
      form.setAttribute('aria-busy', 'true');
      buttons.forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(base + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:form.elements.id.value,quantity:1}]})});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw Error('Basket update failed');
        if (buyNow) {
          if (checkoutWindow) checkoutWindow.location.href = base + 'checkout';
          else location.assign(base + 'checkout');
        } else {
          const link = document.createElement('a');
          link.href = base + 'cart';
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) link.href += '?preview_theme_id=' + encodeURIComponent(preview);
          link.textContent = labels.basket;
          status.replaceChildren(document.createTextNode(labels.added + ' '), link);
          status.hidden = false;
          const cart = await fetch(base + 'cart.js', {credentials:'same-origin'}).then(r => r.ok ? r.json() : null).catch(() => null);
          if (cart) document.querySelectorAll('.dn-header-tools > a[href]').forEach(link => {
            if (new URL(link.href).pathname === base + 'cart') {
              const count = link.querySelector('span');
              if (count) count.textContent = String(cart.item_count);
            }
          });
        }
      } catch {
        checkoutWindow?.close();
        error.hidden = false;
      } finally {
        pending = false;
        form.removeAttribute('aria-busy');
        buttons.forEach(button => { button.disabled = false; });
      }
    });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dn-payment-icons"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root = document) => root.querySelectorAll('[data-dn-product-review-link]').forEach(link => {
    if (link.dataset.countReady) return;
    const section = link.closest('[data-dn-pdp]');
    const count = link.querySelector('[data-dn-product-review-count]');
    if (!section || !count) return;
    link.dataset.countReady = 'true';
    const badges = [...section.querySelectorAll('[data-dn-draft-rating]')];
    const update = () => {
      const badge = badges.find(item => !item.hidden && !item.closest('[hidden]'));
      const score = badge?.querySelector('[data-dn-draft-score]')?.textContent || '';
      const match = score.match(/\(([\d,\s]+)\)/) || score.match(/([\d,\s]+)\s+reviews/i);
      const value = match ? '(' + match[1].replace(/\s/g, '') + ')' : '';
      if (count.textContent !== value) count.textContent = value;
      count.hidden = !value;
    };
    const observer = new MutationObserver(update);
    badges.forEach(badge => observer.observe(badge, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['hidden']}));
    section.querySelectorAll('[data-dn-steps-review]').forEach(group => observer.observe(group, {attributes:true,attributeFilter:['hidden']}));
    update();
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dn-service-page"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root = document) => root.querySelectorAll('[data-dn-service]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const content = section.querySelector('[data-dn-service-content]');
    const toc = section.querySelector('[data-dn-service-toc]');
    const headings = [...content.querySelectorAll('h2')];
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = heading.textContent.trim() === 'About The Dog Nook' ? 'business-details' : 'care-section-' + (index + 1);
      if (!toc) return;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.append(link);
      toc.querySelector('ol').append(item);
    });
    if (toc && headings.length) toc.hidden = false;
    if (location.hash === '#business-details') content.querySelector('#business-details')?.scrollIntoView();
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
